import { useEffect, useState } from 'react';
import { getTruck } from '../../../../fleet/features/trucks/trucks.api';

/** Registrations already fetched, kept across list pages and tabs so paging back does not ask again. */
const KNOWN = new Map<string, string>();

/**
 * Registration by truck id for the ids on screen. The work order list carries only `truckId`, so each distinct id is fetched once
 * (`GET /trucks/:id`); an API-side `truckRegistration` on the row would remove these calls and is the follow-up.
 */
export function useTruckRegistrations(truckIds: string[]): ReadonlyMap<string, string> {
  const [registrations, setRegistrations] = useState<ReadonlyMap<string, string>>(new Map(KNOWN));
  const wanted = [...new Set(truckIds)]
    .filter((id) => !KNOWN.has(id))
    .sort()
    .join(',');

  useEffect(() => {
    if (wanted === '') return;
    let cancelled = false;
    Promise.all(
      wanted.split(',').map((id) =>
        getTruck(id)
          .then((truck) => KNOWN.set(id, truck.registration))
          .catch(() => undefined),
      ),
    ).then(() => !cancelled && setRegistrations(new Map(KNOWN)));
    return () => {
      cancelled = true;
    };
  }, [wanted]);

  return registrations;
}
